import { INQUIRY_BASE_URL } from "../../data/constants";

export const buildInquiryUrl = (userId: number): string => {
  const url = new URL(INQUIRY_BASE_URL);
  url.searchParams.set("_field_26", userId.toString());
  return url.toString();
};
